export default __webpack_public_path__ + "static/media/Satellite.d327b26a.svg";